/**
 * The purpose of this function is to select only the classes that are used on the
 * componentized page, so that we are not loading all the classes in the browser.
 */

const CLASS_PROPS = ["primaryClass", "targetClass", "classOverride", "targetClassOverride"]

const filterClasses = (allClasses, pageComponent) => {
  if (!pageComponent) return []

  const prop = Object.keys(pageComponent).find((key) => CLASS_PROPS.includes(key))
  if (prop && pageComponent[prop]) {
    const cls = allClasses.find((c) => Number(c.classId) === Number(pageComponent[prop].classId))
    return cls ? [cls] : []
  }

  const type = pageComponent.internal ? pageComponent.internal.type : ""
  switch (type) {
    case "ContentfulComponentizedPage": {
      // set to var or empty array so map does not fail
      const bodyComponents = pageComponent.bodyComponents || []
      return [
        ...bodyComponents.flatMap((c) => filterClasses(allClasses, c)),
        ...filterClasses(allClasses, pageComponent.announcementBar),
      ]
    }
    case "ContentfulTextWithMedia":
      return [
        ...filterClasses(allClasses, pageComponent.button),
        ...filterClasses(allClasses, pageComponent.secondButton),
      ]

    case "ContentfulFeaturedProductLayout":
      return [
        ...filterClasses(allClasses, pageComponent.form),
        ...filterClasses(allClasses, pageComponent.productDescription),
      ]

    case "ContentfulPageNavigationBar":
    case "ContentfulAnnouncementBar":
      return [
        ...filterClasses(allClasses, pageComponent.ctaButton),
        ...filterClasses(allClasses, pageComponent.secondaryCTAButton),
      ]

    case "ContentfulHero":
      return [
        ...filterClasses(allClasses, pageComponent.button),
        ...filterClasses(allClasses, pageComponent.secondaryButton),
      ]

    case "ContentfulPurchaseForm":
      return [...filterClasses(allClasses, pageComponent.targetClassOverride)]

    case "ContentfulGridLayout":
      return pageComponent.items?.flatMap((i) => filterClasses(allClasses, i)) ?? []

    case "ContentfulCard":
      if (pageComponent.itemType === "Class") {
        const cls = allClasses.find((c) => Number(c.classId) === Number(pageComponent.itemId))
        return cls ? [cls] : []
      }
      return []

    default:
      return []
  }
}

module.exports = filterClasses
